/** Extract the hostname from a URL, stripping the `www.` prefix. */
export function getDomain(url: string): string {
   try {
      return new URL(url).hostname.replace(/^www\./, "");
   } catch {
      return url;
   }
}

/**
 * Guard a `returnUrl`-style value against open-redirect abuse.
 *
 * Only accepts single-slash internal paths (e.g. `/dashboard`). Rejects
 * protocol-relative (`//host`, `/\host`), absolute URLs, and any encoded
 * variants that decode into the above (e.g. `/%2Fhost`, `/%5Chost`).
 */
export function isSafeInternalPath(value: unknown): value is string {
   if (typeof value !== "string" || value.length === 0) return false;
   if (!value.startsWith("/")) return false;
   if (value.startsWith("//") || value.startsWith("/\\")) return false;

   let decoded: string;
   try {
      decoded = decodeURIComponent(value);
   } catch {
      return false;
   }
   if (decoded.startsWith("//") || decoded.startsWith("/\\")) return false;
   if (decoded.length >= 2 && decoded[0] === "/" && (decoded[1] === "/" || decoded[1] === "\\")) {
      return false;
   }
   return true;
}
